import type { FeatureSplitData } from '@/content/types';

export default function FeatureSplit(props: FeatureSplitData) {
  const reverse = props.imagePosition === 'left';
  return (
    <section className="container section-padding">
      <div className={reverse ? 'split-2col reverse' : 'split-2col'}>
        <div>
          {props.eyebrow && <div style={{ fontSize: 14, color: 'var(--color-muted)', marginBottom: 12 }}>{props.eyebrow.label}</div>}
          <h2 className="h-feature" style={{ marginBottom: 16 }}>{props.title}</h2>
          {props.lines.map((l, i) => <p key={i} style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>{l}</p>)}
          <p style={{ marginTop: 16, color: 'var(--color-muted)' }}>{props.body}</p>
          <a href={props.cta.href} className="btn-ghost" style={{ marginTop: 24 }}>
            {props.cta.label} →
          </a>
        </div>
        <div>
          <img src={props.image.src} alt={props.image.alt} width={props.image.width} height={props.image.height} loading="lazy" decoding="async" style={{ borderRadius: 16, width: '100%', height: 'auto' }} />
        </div>
      </div>
    </section>
  );
}
